var core = require('./core_last.js');

var currentReg;

$(document).ready(function () {
    currentReg = core.getCurrentReg();

    $('#othInfo').html(currentReg != 52
        ? 'Иная информация'
        : 'Тарифы на социальное обслуживания')

    if (currentReg == 52) { // для нижнего свети отдельный вариант (по сути это 2 разные вкладки, важная штука)
        $('#aTarAndUsl').hide()
        $('#aTarAndUslNij').show()
        $('#aUpoln').hide()
        $('#aUchred').hide()
        $('#aGalera').hide()
       // getInform(4.5)
    } else {
        $('#aTarAndUsl').show()
        $('#aTarAndUslNij').hide()
    }

    $('#aStrPodr').html(currentReg != 52
        ? 'Структурные подразделения'
        : 'Структурные подразделения и оказываемые услуги');

    $('#gototop').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });

    let resp = core.urlToObj(false);
    if (resp && resp.cert) {
        $(`#rpost`).toggle();
        $(`#rcert`).toggle();
        $(`.reestr-isp`).toggle();
    }

    getInform(0);

    $('#vidUslCntrl').on('change', function () {
        let urlData = core.urlToObj(false);
        let sentObj = {};
        sentObj.orgId = urlData.id;
        sentObj.sfp = urlData.sfp;
        sentObj.formId = $('#formObslCntrl').val();
        sentObj.vidId = $('#vidUslCntrl').val();
        core.sentAjaxTo('GetTarifInfo', sentObj);
    })

    $('#formObslCntrl').on('change', function () {
        let sendObj = {};
        let urlData = core.urlToObj(false);

        sendObj.orgId = urlData.id;
        sendObj.idVidUsl = $('#formObslCntrl').val();
        core.sentAjaxTo('GetDataforSelector', sendObj);
    })

    lastSim.innerHTML = $('#comm_').attr("maxlength");
    comm_.onkeyup = comm_.oninput = showCount;
    comm_.onpropertychange = function () {
        if (event.propertyName == "value") showCount();
    }
    comm_.oncut = function () {
        setTimeout(showCount, 0); // на момент oncut значение еще старое
    };


    $('.start_an').on('click', function () {
        var sentObj = {};
        core.sentAjaxTo('GetQuestions', sentObj);
    })

    $('.test-window').on('click', '.answer', function (e) {
        var questId = this.id;
        clickBtn(questId);
    })

    var data = sessionStorage.getItem('setComment');
    var dataQ = sessionStorage.getItem('setQuestion');
    if (data == 'true')
        $('.comment-btn').hide();
    else
        $('.comment-btn').show();
    if (dataQ == 'true')
        $('.start_an').hide();
    else
        $('.start_an').show();

})

//наполнение контентом блока в соответствии с выбранной вкладкой меню
export function setDataContent(id, Obj) {
    // изменение положения меню
    $('.menu_block').find('.active').removeClass('active');
    $(Obj).addClass('active');
    $('.caption_menu').text(Obj.text);

    // заполнение блока по выбранной вкладке
    const classItem = 'content_menu__body_item_';
    let $curObj = $('.content_menu__body').find('.active');
    $curObj.hide();
    $curObj.removeClass('active')
    let classItemId = id.toString().replace('.', '_')
    $('.' + classItem + classItemId).show();
    $('.' + classItem + classItemId).addClass('active');
    // отобразить кнопку написания отзывов
    if (id == 11)
        $('.logo_comment_button').show();
    else
        $('.logo_comment_button').hide();
    getInform(id);
}

function getInform(lookupTable) {
    let resp = core.urlToObj(false);
    let sentObj = {};
    sentObj.orgId = resp.id;
    switch (lookupTable) {
        case 0:
            if (!$('.base_info__container').is(":visible"))
                core.sentAjaxTo('GetBasicInfo', sentObj);
            break;
        case 1:
            if (!$('.content_struct_unit__container').children('div').length > 0)
                core.sentAjaxTo('GetStructUnitsInfo', sentObj);
            break;
        case 2:
            if (!$('.content_forms__container').children('div').length > 0)
                core.sentAjaxTo('GetFormsInfo', sentObj);
            break;
        case 3:
            if (!$('.license_tbl').is(":visible"))
                core.sentAjaxTo('GetLicenseInfo', sentObj);
            break;
        case 4:
            if (!$('.tarif_container').children('div').length > 0)
                core.sentAjaxTo('GetDataforSelector', sentObj);
            break;
        case 4.5:
            if (!$('.tarif_tbl').is(":visible"))
                core.sentAjaxTo('GetDataforSelector', sentObj);
            break;
        case 5:
            if (!$('.free_place_tbl').is(":visible"))
                core.sentAjaxTo('GetFreePlaceInfo', sentObj);
            break;
        case 6:
            if (!$('.usl_pred_container').is(":visible"))
                core.sentAjaxTo('GetUslPred', sentObj);
            break;

        case 7:
            if (!$('.verefication_tbl').is(":visible"))
                core.sentAjaxTo('GetVerificationInfo', sentObj);
            if (!$('.violations_tbl').is(":visible"))
                core.sentAjaxTo('GetViolationsInfo', sentObj);
            break;
        case 8:
            if (!$('.work_tbl').is(":visible"))
                core.sentAjaxTo('GetWorkInfo', sentObj);
            break;
        case 9:
            if (!$('.doc_tbl__container').is(":visible"))
                core.sentAjaxTo('GetOtherInfo', sentObj);
            break;
        case 10:
            if (!$('.pick_container').is(":visible"))
                core.sentAjaxTo('GetGaleryInfo', sentObj);
            break;
        case 11:
            core.sentAjaxTo('GetOrgRating', sentObj);
            break;
        case 12:
            core.sentAjaxTo('GetCaptionGroupОfАctivities', sentObj);
            break;
        case 13:
            core.sentAjaxTo('GetAuthorizedOrganizations', sentObj);
            break;
        case 14:
            core.sentAjaxTo('GetFounders', sentObj);
            break;
        case 15:
            core.sentAjaxTo('GetInformationAboutGovernmentServices', sentObj);
            break;
    }

}


var parseUrl = function (value) {
    if (value.indexOf('http') != -1 || value.indexOf('https') != -1)
        return value;
    else
        return 'http://' + value;
};

//основная информация 
export function setBasicInform(resp) {
    if (resp != null) {
        $('.base_info__container').show();
        let req = core.urlToObj(false);
        let str = '';
        $('.caption_org').html(resp.naimk);
        if (resp.isispsert.toLowerCase() === 'true')
            $('#informGovServices').show();
        else
            $('#informGovServices').hide();

        $.each(resp, (key, value) => {
            switch (key) {
                case 'fra_mest_addr':
                case 'fra_mest_addr_ur':
                    str = value + ' <a class="base_link" href="./maps_last.html?orgId=' + req.id + '" data-toggle="tooltip" data-html="true" title="Посмотреть на карте"><span class="glyphicon glyphicon-flag"></span></a>';
                    break;
                case 'email':
                    str = ' <a class="base_link" href="mailto:' + value + '">' + value + '</a>';
                    break;
                case 'website':
                    str = `<a class="base_link" href=${parseUrl(value)} target="_blank"  rel="noopener noreferrer" data-toggle="tooltip" data-placement="top" title="${value}">Перейти </a>`;
                    break;
                case 'isauthorized':
                    str = 'Нет, данных.';
                    if (value == '0')
                        str = 'Нет, не является.';
                    if (value == '1')
                        str = 'Да, является.';
                    break;
                case 'opf':
                    str = currentReg == 52
                        ? value.split('-').pop()
                        : value
                    break;
                default:
                    str = value;
            }
            $('.base_information').find('#' + key).html(str);
        });
    }
}

// условия предоставления
export function setUslPred(resp) {
    if (resp && resp.length > 0) {
        var txt = '<ul>'
        resp.forEach((item) => {
            var c = item.v.indexOf('<');
            if (c > 0)
                txt += '<li style="list-style-type: square; list-style-position: outside; word-wrap: break-word">' + item.v.substring(0, c) + '</li>';
            else
                txt += '<li style="list-style-type: square; list-style-position: outside; word-wrap: break-word">' + item.v + '</li>';
        })
        $('.usl_container').html(txt)
    }
    else $('.usl_container').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации о лицензиях данного поставщика</p>')
    //else $('.usl_container').html('<b>Условия бесплатного предоставление социальных услуг</b><br/>Социальные услуги в форме социального обслуживания на дому, в полустационарной и стационарной формах социального обслуживания предоставляются бесплатно: <br/>1) несовершеннолетним детям; <br/>    2) лицам, пострадавшим в результате чрезвычайных ситуаций, вооруженных межнациональных(межэтнических) конфликтов.<br/>        Социальные услуги в форме социального обслуживания на дому и в полустационарной форме социального обслуживания предоставляются бесплатно, если на дату обращения среднедушевой доход получателя социальных услуг, рассчитанный в соответствии с нормативными правовыми актами Российской Федерации, ниже предельной величины или равен предельной величине среднедушевого дохода для предоставления социальных услуг бесплатно, установленной законом субъекта Российской Федерации.<br/>            Нормативными правовыми актами субъектов Российской Федерации могут быть предусмотрены иные категории граждан, которым социальные услуги предоставляются бесплатно.<br/>                Порядок определения среднедушевого дохода для предоставления социальных услуг бесплатно для целей настоящего Федерального закона устанавливается Правительством Российской Федерации.<br/>                    Размер предельной величины среднедушевого дохода для предоставления социальных услуг бесплатно устанавливается законами субъекта Российской Федерации и не может быть ниже полуторной величины прожиточного минимума, установленного в субъекте Российской Федерации для основных социально - демографических групп населения.<br/>                        <br/>                        <br/>                        <b>Условия платного предоставление социальных услуг и определение размера платы</b> <br/>Социальные услуги в форме социального обслуживания на дому и в полустационарной форме социального обслуживания предоставляются за плату или частичную плату, если на дату обращения среднедушевой доход получателей социальных услуг, рассчитанный в соответствии с частью 4 статьи 31 настоящего Федерального закона, превышает предельную величину среднедушевого дохода, установленную частью 5 статьи 31 настоящего Федерального закона.<br/>        Размер ежемесячной платы за предоставление социальных услуг в форме социального обслуживания на дому и в полустационарной форме социального обслуживания рассчитывается на основе тарифов на социальные услуги, но не может превышать пятьдесят процентов разницы между величиной среднедушевого дохода получателя социальной услуги и предельной величиной среднедушевого дохода, установленной частью 5 статьи 31 настоящего Федерального закона.<br/>            Социальные услуги в стационарной форме социального обслуживания предоставляются их получателям за плату или частичную плату, за исключением получателей социальных услуг, указанных в частях 1 и 3 статьи 31 настоящего Федерального закона.<br/>                Размер ежемесячной платы за предоставление социальных услуг в стационарной форме социального обслуживания рассчитывается на основе тарифов на социальные услуги, но не может превышать семьдесят пять процентов среднедушевого дохода получателя социальных услуг, рассчитанного в соответствии с частью 4 статьи 31 настоящего Федерального закона.<br/>                    Плата за предоставление социальных услуг производится в соответствии с договором о предоставлении социальных услуг, предусмотренным статьей 17 настоящего Федерального закона.<br/><br/>	');
}

//структурная информация
export function setStructInfo(resp) {

    /**
  * Метод для построения запросов на сервер
  * @param {any} url
  * @param {any} caption
  * @param {any} body
  */
    var _fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };

    /**
 * Преобразование адреса в координаты
 * @param {any} address
 */
    var _addressToCoord = async (address) => {
        const url = 'https://geocode-maps.yandex.ru/1.x/?apikey=96634707-c741-4bf6-95a2-54764a2e1f1e&format=json&geocode=' + address,

            promise = await fetch(url),
            responseData = await promise.json();
        try {
            return responseData.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ');
        }
        catch (err) {
            concole.table(err);
            return false;
        }
    };


    let text = '';
    if (Object.entries(resp).length > 0) {

        resp.forEach((value) => {
            let item = value;
            text += '<div class="card content_struct_unit__item">';
            text += '<div class="card-block">';
            text += '<h4 class="card-title" style="font-size:1.25rem">' + item.caption + '</h4>';

            text += '<h6 class="card-subtitle mb-2 text-muted">адрес: ' + item.addr + ' <a class="base_link" href="./maps_last.html?orgId=' + item.base_id + '" data-toggle="tooltip" data-html="true" title="Посмотреть на карте"><span class="glyphicon glyphicon-flag"></span></a>';
            if (item.ntel)
                text += '<br />номер телефона: ' + item.ntel
            if (item.grafic)
                text += '<br />график работы: ' + item.grafic
            if (item.obslF)
                text += '<br />формы обслуживания: ' + item.obslF
            text += '</h6 >'

            if (item.sfpMainNkod != '')
                text += '<h6 class="card-subtitle mb-2 text-muted">относится к структурному подразделению: ' + item.sfpMainNkod + ' </h6>';
            if (item.value.length > 0)
                text += '<a class="card-link struct_unit__link" data-toggle="collapse" href="#collapse_' + item.id + '" aria-expanded="false" aria-controls="collapse_' + item.id + '"> Список услуг</a>';
            text += '<div class="collapse" id = "collapse_' + item.id + '">';
            text += '<ul class="list-group">';

            if (item.hasOwnProperty('latitude') && item.hasOwnProperty('longitude')) {
                if (item.latitude == '' && item.longitude == '') {
                    const promise = _addressToCoord(item.addr)
                        .then((arrPoint) => {
                            _fetchAsync("./ASPWebDataServise.asmx/", 'SetContactCoordinate', {
                                structSfpID: item.sfp,
                                orgId: item.base_id,
                                latitude: arrPoint[1],
                                longitude: arrPoint[0]
                            });
                        });
                }
            }

            let arr_ = item.value;
            arr_.forEach((value_, index_,) => {
                text += `<li class="list-group-item item__forms">   
<a class="getTarifBtn" data-toggle="collapse" href="#collapseStruct_${value_.v}" id="${value_.v}_${item.sfp}">
${(index_ + 1)}. ${value_.k}</a>
</li>`;
                text += `<div id="collapseStruct_${value_.v}" class="pl-5 collapse in"></div>`;
            });
            text += '</ul></div></div></div>';
        });

    }
    else
        text = `Нет информации по структурным подразделениям`;

    $('.content_struct_unit__container').html(text);


    $('.getTarifBtn').click(function (e) {
        let currId = e.currentTarget.id;

        if (!currId) {
            return false;
        }

        let IdServices = currId.split('_')[0],
            IdOrganization = currId.split('_')[1],
            urlData = core.urlToObj(false),
            sendObj = {
                IdServices: IdServices,
                IdOrganization: IdOrganization,
                orgId: urlData.id
            }

        // отрисовка тарифа по услуге 
        function _setInfo(data) {

            let id = data.Id,
                listInfo = data.ListInfo,
                txt = '';

            listInfo.forEach((tmpItem) => {
                txt += ' <div class="blockTarif p-2">';
                txt += ' <div class="d-flex flex-column">';
                txt += '               <div class="p-0">';
                txt += '                  <div class="d-flex flex-row">';
                txt += '                       <div class="p-0">Тип услуги: </div>';
                txt += '                      <div class="p-0 master_color">' + tmpItem.tip + '</div>';
                txt += '                  </div>';
                txt += '              </div>';
                txt += '               <div class="p-0">';
                txt += '                  <div class="d-flex flex-row">';
                txt += '                       <div class="p-0">Количество (объем) предоставляемой услуги в периоде: </div>';
                txt += '                      <div class="p-0 master_color">' + tmpItem.kolv + '</div>';
                txt += '                  </div>';
                txt += '              </div>';
                txt += '              <div class="p-0">';
                txt += '                 <div class="d-flex flex-row">';
                txt += '                      <div class="p-0">Единица предоставления: </div>';
                txt += '                      <div class="p-0 master_color">' + tmpItem.s_edizm_nkod + '</div>';
                txt += '                   </div>';
                txt += '               </div>';
                txt += '              <div class="p-0">';
                txt += '                 <div class="d-flex flex-row">';
                txt += '                      <div class="p-0">Тариф: </div>';
                txt += '                      <div class="p-0 master_color">' + tmpItem.tarif + '</div>';
                txt += '                   </div>';
                txt += '               </div>';
                txt += '              <div class="p-0">';
                txt += '                 <div class="d-flex flex-row">';
                txt += '                      <div class="p-0">Дата начала действия тарифа: </div>';
                txt += '                      <div class="p-0 master_color">' + tmpItem.dataN + '</div>';
                txt += '                   </div>';
                txt += '               </div>';
                txt += '              <div class="p-0">';
                txt += '                   <div class="d-flex flex-row">';
                txt += '                       <div class="p-0">Периодичность: </div>';
                txt += '                       <div class="p-0 master_color">' + tmpItem.period + '</div>';
                txt += '                   </div>';
                txt += '              </div>';
                txt += '              <div class="p-0">';
                txt += '                   <div class="d-flex flex-row">';
                txt += '                       <div class="p-0">Группы тарификации: </div>';
                txt += '                       <div class="p-0 master_color">' + tmpItem.groupTarif + '</div>';
                txt += '                   </div>';
                txt += '              </div>';
                txt += '              <div class="p-0">';
                txt += '                   <div class="d-flex flex-row">';
                txt += '                       <div class="p-0">Форма обслуживания: </div>';
                txt += '                       <div class="p-0 master_color">' + tmpItem.formobsl + '</div>';
                txt += '                   </div>';
                txt += '              </div>';
                txt += '           </div>';
                txt += '       </div>';
                if (listInfo.length > 1 && listInfo.indexOf(tmpItem) != listInfo.length - 1)
                    txt += '<div style="flex-grow: 1; flex-basis: auto; border-bottom: 1px solid #dddddd;" />' // палочка между тарифами
            });

            $(`#collapseStruct_${id}`).html(txt)
        }

        $.ajax({
            type: "Post",
            url: "./ASPWebDataServise.asmx/GetTarifInfoFromServices",
            data: "{inputsParam:'" + JSON.stringify(sendObj) + "'}",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                var data = JSON.parse(response.d);
                _setInfo(data);
            }
        });

    });

}

// информация о формах социального обслуживания
export function setFormsInfo(resp) {
    let text = '';

    if (!Object.keys(resp).length) {
        text = `<p style="font-size:x-large; color:red;">Данные не были получены</p>`
        $('.content_forms__container').html(text);
        return
    }
    resp.forEach((value, index, resp) => {
        let item = value;
        text += '<div class="content_forms__item">';
        text += '<h2 class="forms_caption">' + core.replaceBrackets(value.caption) + '</h2>'
        text += '<ul class="list-group">';

        let item_arr = item.value;

        item_arr.forEach((value_, index_, item_arr) => {
            let usl = value_;
            text += '<li class="list-group-item item__forms" >' + usl.v + '</li >';
        })
        text += '</ul></div>';
    })
    $('.content_forms__container').html(text);
}

// информация о лицензиях
export function setLicenseInfo(resp) {
    if (resp.length > 0) {
        $('.license_tbl').show();
        let text = '';
        resp.forEach((value, index, resp) => {
            let item = value;
            let docInfo = '№' + item.seria + ' ' + item.nomer + ' от ' + item.datd + ', действует от ' + item.sroks + ' ' + item.sved;
            text += '<tr><td style="text-align:center">' + (index + 1) + '</td><td>' + item.name + '</td><td>' + docInfo + '</td><td>' + item.org + '</td><td>';
            if (item.imageid != '')
                text += '<a class="base_link" target="_blank" href="./img.ashx?id=' + item.imageid + '" rel="noopener noreferrer">' + item.imagename + ' (Скачать)</a>';
            text += '</td></tr>';
        })
        $('#license_tbl').html(text);
    }
    else
        $('.license_tbl__container').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации о лицензиях данного поставщика</p>')
}


function getImage(imgId) {
    return './ASPWebDataServise.asmx/GetFile?id=' + imgId;
    //return './img.ashx?id=' + imgId;
}

//информация о свободных местах
export function setFreePlaseInfo(resp) {
    let text = '';
    if (resp.length > 0) {
        $('.free_place_tbl').show();
        let sum_sv = 0,
            sum_ob = 0;
        resp.forEach((value, index, resp) => {
            let item = value;
            if (parseInt(item.kolmest_sv) !== 0 || parseInt(item.kolmest_ob) !== 0) {
                sum_sv += parseInt(item.kolmest_sv);
                sum_ob += parseInt(item.kolmest_ob);
                text += '<div class="form-free"><dl class="row row-free">';
                text += '<dt class="col-12 col-sm-3">Наименование</dt><dd class="col-12 col-sm-9">' + item.nkod + '</dd>';
                text += '</dl><dl class="row row-free">';
                text += '<dt class="col-12 col-sm-3">Тип подразделения</dt><dd class="col-12 col-sm-9">' + item.tip_name + '</dd>';
                text += '</dl> <dl class="row row-free"><dt class="col-sm-3">Адрес</dt>';
                text += '<dd class="col-sm-9">' + item.fra_addr + ' <a class="base_link" href="./maps_last.html?orgId=' + item.f_reestrpost_id + '" data-toggle="tooltip" data-html="true" title="Посмотреть на карте"><span class="glyphicon glyphicon-flag"></span></a></dd>';
                text += '</dl> <dl class="row row-free"><dt class="col-sm-3">Форма обслуживания</dt>';
                text += '<dd class="col-sm-9">' + core.replaceBracketsArr(item.formobsl.substr(2), ';') + '</dd>';
                text += '</dl> <dl class="row row-free"><dt class="col-sm-3">Категория граждан</dt>';
                text += '<dd class="col-sm-9">' + item.naimgr.substr(2) + '</dd>';
                text += '</dl> <dl class="row row-free"> <dt class="col-sm-3">Количество мест</dt>';
                text += '<dd class="col-sm-9"> всего мест: ' + item.kolmest_ob + ' свободно: ' + item.kolmest_sv + '</dd></dl></div>';
            }
        });


        let infoText = `<div class="form-free">
                            <dl class="row row-free">
                                <dt class="col-12 col-sm-3">Количество мест всего:</dt>
                                <dd class="col-12 col-sm-9">${sum_ob}</dd>
                            </dl>
                            <dl class="row row-free">
                                <dt class="col-12 col-sm-4">Количество мест всего свободно:</dt>
                                <dd class="col-12 col-sm-8">${sum_sv}</dd>
                            </dl>
                        </div>`;

        $('.free_place_tbl__containerr').html(infoText + text);

    }
    else
        $('.free_place_tbl__containerr').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации о свободных местах </p>')
}

//информация о проверках
export function setVereficationInfo(resp) {
    if (resp.length > 0) {
        $('.verefication_tbl').show();
        let text = '';
        resp.forEach((value, index, resp) => {
            let item = value;
            text += '<tr><td style="text-align:center">' + (index + 1) + '</td><td>' + item.vid + '</td><td>' + item.datprov + '</td><td>' + item.s31 + '</td><td> ';
            if (item.id && item.filename)
                text += `<a class="base_link" target="_blank" href="./img.ashx?id=p${item.id}" rel="noopener noreferrer">${item.filename}(Скачать)</a>`;
            text += '</td><td>' + item.comment + '</td ></tr > ';
        })
        $('#verefication_tbl').html(text);
    }
    else {
        $('.vv_tbl__container').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации </p>');
    }
}

//информация о нарушениях
export function setViolationsInfo(resp) {
    let text = '';
    if (resp.length > 0) {
        $('.violations_tbl').show();
        resp.forEach((value, index, resp) => {
            let item = value;
            let dat_ = (item.datustrP != '' ? 'Предписанная дата устранения нарушения: ' + item.datustrp : '') + '</br> ' + (item.datustrf != '' ? '  Фактическая дата устранения нарушения:' + item.datustrf : '');
            text += '<tr><td style="text-align:center">' + (index + 1) + '</td><td>' + item.datprov + '</td><td>' + item.narush + '</td><td>' + dat_ + '</td></tr> ';
        })
        $('#violations_tbl').html(text);
    }
    else $('.violations_tbl').hide();
}

// информация об опыте работы
export function setWorkInfo(resp) {
    let text = '';
    if (resp.length > 0) {
        $('.work_tbl').show();
        resp.forEach((value, index) => {
            let item = value,
                docinfo = ''
            if (item.nomer)
                docinfo += '№' + item.nomer
            if (item.datd)
                docinfo += ' от ' + item.datd
            if (item.sroks)
                docinfo += `${(docinfo ? ', ' : '')}действует c ` + item.sroks
            text += '<tr><td style="text-align:center">' + (index + 1) + '</td><td>' + item.s24 + '</td>';
            if (docinfo)
                text += '<td>' + docinfo + '</td>';
            else
                text += '<td>Отсутствует</td>'
            text += '<td><div style="text-align: justify; max-height:400px; overflow:auto ">' + item.s31 + '</div></td><td> '
            if (item.scanid != null && item.scanid != '')
                text += '<a class="base_link" target="_blank" href="./img.ashx?id=' + item.scanid + '" rel="noopener noreferrer">' + item.filename + ' (Скачать)</a>';
            text += '</td></tr > ';
        });
        $('#work_tbl').html(text);
    }
    else
        $('.work_tbl__container').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации об опыте работы организации за последние 5 лет </p>');
}

export function setTarigTbl(resp) {
    if (resp && !'Description' in resp && Object.keys(resp).length) {
        let tbody = ''
        resp.forEach((value, index) => {
            tbody += `
<tr>
    <td style="text-align: center;">${index + 1} </td>
    <td style="text-align: justify;">${value.naim}</td>
    <td style="text-align: justify;">${value.info}</td>
    <td style="text-align: center;">
        ${(value.scandoc_id
                ? `<a class="base_link" target="_blank" href="./img.ashx?id=${value.scandoc_id}" rel="noopener noreferrer">
                    ${(value.filename ? value.filename : 'Файл без названия')} (Скачать)
                  </a>`
                : 'Файл отсутствует')}</td>
</tr>
`
        })
        let txt = `
<div class = "container tarif_tbl__container">
    <table class = "table table-striped table-sm table-bordered res_grid_table tarif_tbl">
        <thead>
            <tr>
                <th style="width: 10%">N п/п</th>
                <th style="width: 25%">Наименование</th>
                <th style="width: 60%">Данные о документе</th>
                <th style="width: 5%">Файл</th>
            </tr>
        </thead>
        <tbody>
            ${tbody}
        </tbody>
    </table>
</div>
`
        $('.tarif_container').html(txt)
    } else {
        $('.tarif_container').html('<p style="font-size:x-large;">К сожалению нет информации о уставных документах и свидетельствах</p>')
    }
}

// информация о тарифах на услуги
export function setTarifInfo(resp) {
    if (Object.entries(resp).length > 0 && Object.entries(resp.TarifList).length > 0) {
        var txt = '',
            arrTarif = resp.TarifList;
        if (arrTarif !== undefined) {

            //$('.selector_panel_tarif').show();

            txt += ' <div class="p-2">';
            txt += '<div>' + resp.Description + '</div>';
            txt += '   <table class="table table-striped table-sm table-bordered res_grid_table">';
            txt += '   <thead>';
            txt += '   <tr style="height:2.5rem">';
            txt += '       <th style="width: 7%;"> N п/п</th>';
            txt += '       <th style="width: 61%;">Наименование услуги</th>';
            //txt += '       <th style="width: 14%;">Тариф (руб) </th>';
            //txt += '       <th style="width: 27%;">Дата начала действия тарифа</th>';
            txt += '       <th style="width: 4%;"></th>';
            txt += '   </tr>';
            txt += '</thead >';

            arrTarif.forEach((value, index) => {
                txt += '<tr class="accordion-toggle">';
                txt += '<td class="td_center">' + (index + 1) + '</td>';
                txt += '<td >' + value.Description + '</td>';
                //txt += '<td class="td_center">' + value.tarif + '</td>';
                //txt += '<td class="td_center">' + value.dataN + '</td>';
                txt += '<td><button type="button" class="btn btn-sm btn-outline-primary" data-toggle="collapse" data-target="#collapse_' + index + '"><i class="glyphicon glyphicon-plus" aria-hidden="true" style="left:1px; top:0"> </i></button></td>';
                txt += '</tr>';
                txt += '<tr><td></td><td colspan="4"><div id="collapse_' + index + '" class="collapse in">';
                txt += '<forms id= "form_' + index + '">';

                let tarifList = value.TarifList;
                tarifList.forEach((tmpItem) => {
                    txt += ' <div class="blockTarif p-2">';
                    txt += ' <div class="d-flex flex-column">';
                    txt += tmpItem.vid_uch && tmpItem.vid_uch !== 'не указано' ? `<div class="p-0">
                                     <div class="d-flex flex-row">
                                          <div class="p-0">Вид учреждения: </div>
                                          <div class="p-0 master_color">${tmpItem.vid_uch}</div>
                                      </div>
                                   </div>` : ``;
                    txt += tmpItem.tip && currentReg != 52 ? `<div class="p-0">
                                      <div class="d-flex flex-row">
                                           <div class="p-0">Тип услуги: </div>
                                          <div class="p-0 master_color">${tmpItem.tip}</div>
                                      </div>
                                  </div>` : ``;
                    txt += tmpItem.kolv ? `<div class="p-0">
                                     <div class="d-flex flex-row">
                                          <div class="p-0">Количество (объем) предоставляемой услуги в периоде: </div>
                                         <div class="p-0 master_color">${tmpItem.kolv}</div>
                                     </div>
                                  </div>` : ``;
                    txt += tmpItem.s_edizm_nkod ? `<div class="p-0">
                                     <div class="d-flex flex-row">
                                          <div class="p-0">Единица предоставления: </div>
                                          <div class="p-0 master_color">${tmpItem.s_edizm_nkod}</div>
                                       </div>
                                   </div>` : ``;
                    txt += tmpItem.tarif ? `<div class="p-0">
                                     <div class="d-flex flex-row">
                                          <div class="p-0">Тариф: </div>
                                          <div class="p-0 master_color">${tmpItem.tarif}</div>
                                       </div>
                                   </div>` : ``;
                    txt += currentReg != 52 ? `<div class="p-0">
                                     <div class="d-flex flex-row">
                                          <div class="p-0">Дата начала действия тарифа: </div>
                                          <div class="p-0 master_color">${tmpItem.dataN ? tmpItem.dataN : tmpItem.datan}</div>
                                       </div>
                                   </div>` : '';
                    txt += tmpItem.period ? `<div class="p-0">
                                       <div class="d-flex flex-row">
                                           <div class="p-0">Периодичность: </div>
                                           <div class="p-0 master_color">${tmpItem.period}</div>
                                       </div>
                                  </div>` : ``;
                    txt += tmpItem.s_gruptarif_nkod ? `<div class="p-0">
                                       <div class="d-flex flex-row">
                                           <div class="p-0">Группа тарификации: </div>
                                           <div class="p-0 master_color">${tmpItem.s_gruptarif_nkod}</div>
                                       </div>
                                  </div>` : ``;
                    txt += '           </div>';
                    txt += '       </div>';
                    if (tarifList.length > 1 && tarifList.indexOf(tmpItem) != tarifList.length - 1)
                        txt += '<div style="flex-grow: 1; flex-basis: auto; border-bottom: 1px solid #dddddd;" />' // палочка между тарифами
                });
                txt += '       </forms></div>';
                txt += '</td ></tr > ';
            });
            txt += '</table></div>';
        }
    }
    else {
        //$('.selector_panel_tarif').hide();
        txt = '<h3 class="text-center mt-4">К сожалению нет информации о тарифах</h3>';
    }
    $('.tarif_container').html(txt);
}

//заполнение селектора формы обслуживания
export function setFormsObslCntrl(resp) {
    var sendObj = {},
        urlData = core.urlToObj(false);

    if (Object.entries(resp).length > 0) {
        let txt = '';
        resp.forEach((value, index, resp) => {
            txt += '<option value="' + value.k + '">' + core.replaceBrackets(value.v) + '</option>';
        });

        $('#formObslCntrl').html(txt).selectpicker('refresh');
        sendObj.idVidUsl = resp[0].k;
    }
    else {
        $('.selector_panel_tarif').hide();
        sendObj.idVidUsl = null;
    }

    sendObj.orgId = urlData.id;
    core.sentAjaxTo('GetDataforSelector', sendObj);
};

//заполнение селектора видов услуг
export function setVidUslCntrl(resp) {
    var urlData = core.urlToObj(false),
        sentObj = {};

    if (resp && resp.length > 0) {
        let txt = '';
        resp.forEach((value, index, resp) => {
            txt += '<option value="' + value.k + '">' + value.v + '</option>';
        })

        $('#vidUslCntrl').html(txt).selectpicker('refresh');
        sentObj.vidId = $('#vidUslCntrl').val();
    }
    sentObj.formId = $('#formObslCntrl').val();
    sentObj.orgId = urlData.id;
    sentObj.sfp = urlData.sfp;
    core.sentAjaxTo('GetTarifInfo', sentObj);
}

//иная информация
export function setOtherInfo(resp) {
    let yInfo = resp.yInfo;
    let docInfo = resp.docInfo;
    let text = '';
    if (yInfo != '') {
        $('.yInfo__container').show();
        $.each(yInfo, (index, value) => {
            $('#' + index).html(value);
        })
    }
    if (docInfo.length > 0) {
        $('.doc_tbl__container').show();
        let txt = '';
        docInfo.forEach((value, index, docInfo) => {
            txt += '<tr><td>' + (index + 1) + '</td><td>' + (value.name == '' ? value.docname : value.name) + '</td><td> ' + (value.datd == '' ? 'нет данных' : ' от ' + value.datd + ', действует с ' + value.sroks) + '</td><td>' + (value.orgname == '' ? 'нет данных' : value.orgname) + '</td>';
            txt += '<td>' + (value.scanfd != '' ? '<a class="base_link" target= "_blank" href= "./img.ashx?id=' + value.scanid + '" > ' + value.filename + '</a >' : '') + '</td></tr>';
        })

        $('#doc_tbl').html(txt);
    }
    else {
        $('.doc_tbl__container').show();
        $('.doc_tbl__container').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации о документах</p>')
    }
}

//заполнение галереи
export function setPictInfo(resp) {
    if (resp.length > 0) {
        $('.pick_container').show();
        $('.pick_container').html('');
        let txt = '';
        resp.forEach((value) => {
            txt += '<div class="col-lg-3 col-md-4 col-xs-6">';
            txt += '<a href= "#" class="d-block mb-4 h-100 gallery" onClick="org.OpenModal(' + value.id + ')" data-toggle="modal"><img class="img-fluid img-thumbnail" src="./img.ashx?f_id=' + value.id + '" alt="" style="height: 150px; width:200px" data-toggle="tooltip" data-html="true" title="' + value.docname + '"/></a></div>';
        })
        $('.pick_container').html(txt)
    }
    else
        $('.pick_container').html('<p style= "width:100%; text-align:center; padding: 1rem" > К сожалению нет информации </p>');
}

//обработчик клика по картинке из галереи
export function OpenModal(id) {
    let sendObj = {};
    let urlData = core.urlToObj(false);
    sendObj.orgId = urlData.id;
    sendObj.idPick = id;
    core.sentAjaxTo('GetGaleryInfo', sendObj);
}

//запрс на получение данных по раскрываемой картинке
export function setSinglePick(resp) {
    if (resp.length > 0) {
        let pick = resp[0];
        let txt = '<img class="img-fluid img-thumbnail" src="' + (pick.photo != null ? " data:image/png; base64, " + pick.photo : "http://placehold.it/400x300") + '"alt=""/>';
        txt += '<p class = "img_caption">' + (pick.filename == '' ? pick.docname : pick.filename) + '</p>'
        $('.img_content').html(txt);
        $('#pickModal').modal('show');
    }
    else
        $('.info-container').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет фото материалов </p>')
}
// заполнение коментариев 
export function setRPostRating(resp) {
    let txt = '';
    if (resp.length == 0)
        txt = '<p style="text-align:center; padding: 1rem">К сожалению нет ни одной записи, будьте первым, кто оставит свой отзыв</p>';
    else
        resp.forEach((value, index, resp) => {
            txt += '<div class="comment p-1" id="c_' + value.id + '"><div class="d-flex flex-column">';
            txt += '<div class="p-1"><div class="d-flex flex-row comment_autor_row">';
            txt += '<div class="p-1"><img class="img-fluid rounded-circle comment__img" src="./images/User.png" /></div>';
            txt += '<div class="p-1 comment__author">' + value.author + '</div></div></div>';
            txt += '<div class="p-1"><h6 class="comment__caption">Комментарий:</h6></div>';
            txt += '<div class="p-1 comment__text">' + value.comment + '</div><div class="p-2"><div class="d-flex justify-content-end">';
            txt += '<div class="mr-auto comment__date">' + (new Date(value.data) != 'Invalid Date' ? new Date(value.data).toLocaleString("ru").split(",")[0] : value.data) + '</div><div>Полезно?</div>';
            txt += '<div class="badge_center" id="but_up" onclick="org.upDownBut_click(this,' + index + ',' + value.id + ')"><span id= "num_up' + index + '" class="badge badge-pill badge-success">' + (value.num_up == '' ? 0 : value.num_up) + '</span></div>';
            txt += '<div class = "badge_right" id="but_down" onclick="org.upDownBut_click(this,' + index + ',' + value.id + ')"><span id= "num_down' + index + '" class="badge badge-pill badge-danger">' + (value.num_down == '' ? 0 : value.num_down) + '</span></div></div></div></div></div>';
        })
    $('.rating_container').html(txt);
}

export function setCaptionGroupОfАctivities(response) {

    var _fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };

    if ($.isEmptyObject(response) || response.HasError || response.Result.length == 0) {
        $('.group-activities-container').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации </p>');
        return false;
    }

    let listCaption = response.Result;
    if (listCaption.length == 0) {
        $('.group-activities-container').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации </p>');
        return false;
    }

    $('.group-activities-container').html('')
    listCaption.forEach((value) => {
        let text = '',
            kod = value.Kod;
        text += '<div class="card group-activities__item">';
        text += '<div class="card-block">';
        //text += '<h4 class="card-title" style="font-size:1.25rem">' + value.Caption + '</h4>';
        text += `<ul class="list-group gac-${kod}"></ul>`;
        text += '</div></div';
        $('.group-activities-container').append(text);

        let urlData = core.urlToObj(false);

        const A = _fetchAsync("./ASPWebDataServise.asmx/", 'GetGroupОfАctivities', {
            orgId: urlData.id,
            kod: kod
        }).then(resp => {
            let A = JSON.parse(resp.d);
            if ($.isEmptyObject(A))
                return false;

            $(`.gac-${kod}`).html('');
            A.forEach((value, index) => {
                $(`.gac-${kod}`).append(`<li class="list-group-item" style="border:none">   ${(index + 1)}. ${value.nkod} </li>`);
            });
        })

    })

}

export function setQuestionList(resp) {
    all_data = resp;
    createQuestion(all_data, 0);
    $('#modal_test').modal('toggle');
}
var all_data = null,
    sendDataTest = [];

var createQuestion = function (d, count) {
    var objQuestion = d.questions[count];
    if (objQuestion) {
        $('.test-window').html('');
        var txt = ' <div class="current-test" id="' + count + '">';
        txt += '<div class="d-flex flex-column">';
        txt += ' <div class="p-2">Вопрос ' + (count + 1) + ' из ' + all_data.questions.length + '</div>';
        txt += '<div class="p-0">';
        txt += '<div class="d-flex flex-row justify-content-center">';
        txt += '    <div class="p-0">';
        txt += '        <h5 >' + objQuestion.caption + '</h5>';
        txt += '    </div>';
        txt += ' </div>';
        txt += '</div>';
        txt += '<div class="p-0">';
        txt += '<div class="d-flex flex-row justify-content-center">';
        txt += '    <div class="p-0">';
        txt += '        <h5 class="question" id="' + objQuestion.id + '">' + objQuestion.name + '</h5>';
        txt += '    </div>';
        txt += '</div>';
        txt += '</div>';
        txt += '<div class="p-2">';
        txt += '<div class="d-flex flex-row justify-content-center">';
        var answ = objQuestion.answers;
        txt += count > 0 ? ' <div class="p-1"><button type="button" class="answer btn btn-outline-primary" id="back">назад</button></div>' : '';
        answ.forEach((value, index, answ) => {
            txt += ' <div class="p-1"><button type="button" class="answer btn btn-secondary" id="btn_' + value.id + '">' + value.name + '</button></div>';

        })
        txt += '</div></div></div></div>';
    }
    else {
        var txt = '<h5>Опрос завершен. Спасибо за участие)</h5>';
        sessionStorage.setItem('setQuestion', true);
        $('.start_an').hide();
    }
    $('.test-window').html(txt).addClass('text-center');
};

var clickBtn = function (id) {

    var currId = parseInt($('.current-test').attr('id'));
    if (id !== 'back') {
        createQuestion(all_data, (currId + 1));
        var obj = {
            q_id: $('.question').attr('id'),
            a_id: id.split('_')[1],
        }
        if (sendDataTest[currId])
            sendDataTest[currId] = obj;
        else
            sendDataTest.push(obj);
    }
    else {
        createQuestion(all_data, (currId - 1));
        var arrItem = sendDataTest[currId - 1];
        var a_id = arrItem.a_id;
        $('#btn_' + a_id).addClass('active');
    }

};



//добавление коментария
export function setInfo() {
    let sendObj = {};
    let urlData = core.urlToObj(false);
    sendObj.orgId = urlData.id;

    let author = $('#author_').val()
    if (author == '') {
        alert('Заполните поле имя!')
        return;
    }
    sendObj.author = author;
    sendObj.comment = $('#comm_').val();
    core.sentAjaxTo('SetOrgRating', sendObj);
    sessionStorage.setItem('setComment', true);
    $('.comment-btn').hide();
}

// обработка результата после добавления отзыва
export function setRPostRatingData(resp) {
    if (resp === 'OK') {
        getInform(11);
        $('#author_').val('');
        $('#comm_').val('');
    }
    else alert('Что то пошло не так ;(')
}

// очистка полей при нажатии кнопки закрыть формы написания отзыва
export function clearComment() {
    $('#author_').val('');
    $('#comm_').val('');
}

//показать остаток символов
function showCount() {
    let maxLength = $('#comm_').attr("maxlength");
    lastSim.innerHTML = (maxLength - comm_.value.length);
}

//обработчик нажатия кнопки у отзыва
export function upDownBut_click(obj, id, idRow) {
    //state:null-впервые; num_up,num_down-предыдущие состояние
    var state = core.getCookie('currentUserState');
    if (state == undefined) {
        setNumUpDownState(id, obj.id, idRow, null);
        document.cookie = 'currentUserState =' + obj.id;
    }
    else {
        setNumUpDownState(id, obj.id, idRow, state);
        core.setCookie('currentUserState', obj.id);
    }
}

//добавление значения "up", "down"
export function setNumUpDownState(i, butCaption, idRow, state) {
    let sendObj = {};
    sendObj.idRow = idRow;
    sendObj.index = i;
    sendObj.butCaption = butCaption;
    sendObj.state = state;

    core.sentAjaxTo('SetNumUpDownStateRating', sendObj)

}

//обработчик запроса на добавление значения "up", "down"
export function setStateRating(resp) {
    $.each(resp, (index, value) => {
        $('#' + index).text(value);
    })
}


export function setAuthorizedOrganizations(resp) {
    if (resp.length > 0) {
        $('.authorizedOrganizations-tbl-err').html('');
        $('.authorizedOrganizations-tbl').show();
        let text = '';
        resp.forEach((item, index) => {
            text += '<tr><td style="text-align:center">' + (index + 1) + '</td><td>' + item.caption + '</td><td>' + item.forma + '</td><td>' + item.comment + '</td></tr>';
        })
        $('#authorizedOrganizations-tbl').html(text);
    }
    else
        $('.authorizedOrganizations-tbl-err').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации </p>')
}

export function setFounders(resp) {

    if (resp.length > 0) {
        $('.founders-tbl-err').html('');
        $('.founders-tbl').show();
        let text = '';
        resp.forEach((item, index) => {
            text += '<tr><td style="text-align:center">' + (index + 1) + '</td><td>' + item.name + '</td><td>' + item.addr + '</td><td>' + item.faktaddr + '</td><td>' + item.phone + '</td><td>' + item.email + '</td></tr>';
        })
        $('#founders-tbl').html(text);
    }
    else
        $('.founders-tbl-err').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации </p>')
}

export function setInformationAboutGovernmentServices(resp) {

    var _fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };

    var rtrnList = (list) => {
        if (list && list.length > 0)
            return list.map(i => `<li>${i.Caption}</li>`).join(' ');
        return 'нет сведений';
    }

    if (resp.length > 0) {
        $('.government-services-err').html('');
        //$('.government-services-success').show();
        let text = '';
        resp.forEach((item, index) => {
            let t = `<div class="p-3" style="width: 100%">
<dl>
    <dt>Дата сведений</dt>
    <dd>${item.Data}</dd>
    <dt>Значения нормативных затрат на оказание государственной (муниципальной) услуги</dt>
    <dd>${item.StandartCost}</dd>
    <dt>Цена (тариф) на оказание государственной (муниципальной) услуги для получателей социального сертификата</dt>
    <dd>${item.Tarif}</dd>
    <dt>Стоимость оказания государственной (муниципальной) услуги в объеме, превышающем определенный социальным сертификатом объем финансового обеспечения ее оказания</dt>
    <dd>${item.Price}</dd>
    <dt>Сведения о порядке оказания государственной (муниципальной) услуги, включающие в себя в том числе сроки, условия и формы оказания государственной (муниципальной) услуги в социальной сфере в отношении получателей социального сертификата</dt>
    <dd>${item.Order}</dd>
    <dt>Номер заключения соглашения о финансовом обеспечении (возмещении) затрат, связанных с оказанием государственных (муниципальных) услуг</dt>
    <dd>${item.NumberOfAgreement}</dd>
    <dt>Дата заключения соглашения о финансовом обеспечении (возмещении) затрат, связанных с оказанием государственных (муниципальных) услуг</dt>
    <dd>${(item.DateOfAgreement == null ? 'нет сведений' : item.DateOfAgreement)}</dd>

<div class="d-flex justify-content-end">

 <button class="btn btn-primary view-services-btn" id="collapse-${item.Id}" type="button" data-toggle="collapse" data-target="#collapse-base-${item.Id}" aria-expanded="false" aria-controls="collapse-base-${item.Id}">
    Подробнее
  </button>
</div>
<div class="collapse" id="collapse-base-${item.Id}">
</div>
</dl>
<hr/>
</div>`;
            $('.government-services-success').append(t);
        });

        $('.view-services-btn').click(function (e) {
            e.preventDefault();
            let currId = e.currentTarget.id,
                ur = core.urlToObj(false);
            if (!currId)
                return;
            let id = currId.split('-')[1],
                promise = _fetchAsync("./ASPWebDataServise.asmx/", 'GetInformationOnTheRegisterRecords', { orgId: ur.id, VsertosnpostId: id })
                    .then(response => {
                        let respServices = JSON.parse(response.d);
                        if (respServices && respServices.length > 0) {
                            $(`#collapse-base-${id}`).html('');
                            respServices.forEach((item) => {
                                let t = `<div class="pl-5 p-2" style="width: 100%">
<dl>
    <dt>Уникальный номер реестровой записи</dt>
    <dd>${item.Nomer}</dd>
    <dt>Наименование государственной(муниципальной) услуги в социальной сфере</dt>
    <dd>${item.Name}</dd>
    <dt>Условия (формы) оказания государственной (муниципальной) услуги в социальной сфере </dt>
    <dd>${item.Formobsl}</dd>

 <dt>Показатели, характеризующие качество оказания государственной (муниципальной) услуги в социальной сфере</dt>
    <dd><ul>${rtrnList(item.ListIndicatorsQuality)}</ul></dd>

    <dt>Признак</dt>
    <dd>${item.IsFree}</dd>
    <dt>Категории потребителей государственных  услуг в социальной сфере (государственных услуг в социальной сфере, составляющих укрупненную государственную услугу)</dt>
    <dd>${item.Category}</dd>
    <dt>Предельный объем оказания государственной (муниципальной) услуги в социальной сфере, заявленный исполнителем услуг, человек</dt>
    <dd>${item.LimitServiceScope}</dd>
    <dt>Объем оказания государственной (муниципальной) услуги (фактический), человек</dt>
    <dd>${(item.ServiceScope == null ? 'нет сведений' : item.ServiceScope)}</dd>
  <dt> Свободный объем оказания государственной (муниципальной) услуги, человек</dt>
    <dd>${(item.FreeServiceScope == null ? 'нет сведений' : item.FreeServiceScope)}</dd>
</dl>
   <hr/>
</div>`;
                                $(`#collapse-base-${id}`).append(t);
                            });
                        }
                    })
        });
    }
    else
        $('.government-services-err').html('<p style= "text-align:center; padding: 1rem" > К сожалению нет информации </p>')
}